export enum IAdvertisementTelevisionActionTypes {
  GET_AD_TV = '@@adTelevision/GET_AD_TV',
  GET_AD_TV_SUCCESS = '@@adTelevision/GET_AD_TV_SUCCESS',
  GET_AD_TV_FAILURE = '@@adTelevision/GET_AD_TV_FAILURE',
}

export interface IAdvertisementTelevision {
  result: AdvertisementTelevisionResult | null;
  isLoading: boolean;
  error: string;
}

export interface AdvertisementTelevisionResult {
  ad: AdTelevision;
  group_ads: GroupAdTelevision[];
  tracks: TrackTelevision[];
}

export interface AdTelevision {
  advertiser_code: number;
  advertiser_name: string;
  arpp_code: string;
  created: string;
  creative_agency_code: number;
  creative_agency_name: string;
  duration: number;
  filmid_label: string;
  first_diffusion: string | null;
  first_diffusion_media: {
    id: number;
    name: string;
  };
  group_id: number;
  id: number;
  internal_name: string;
  product_code: string;
  reference_ad_id: number;
  title: string;
  under_embargo: boolean;
}

export interface GroupAdTelevision {
  arpp_code: string | null;
  filmid_label: string;
  id: number;
}

export interface TrackTelevision {
  artist: any;
  authors: any;
  bed: boolean;
  bucket_name: any;
  composers: string;
  end_time: number;
  fgp_id: number;
  film_group_id: number;
  film_id: number;
  gain: number;
  isrc: any;
  iswc: any;
  master_filepath: any;
  music_state_id: string;
  offset_end: number;
  offset_start: number;
  source: string;
  start_time: number;
  title: string;
}
